(function(){

  if($('.mobile-sticky-footer').length > 0){
    $('.mobile-sticky-footer .cta-button').on('click', function(){
      var redirect_url = $('.offer-container .offer-button-wrap a').attr('href');
      if(redirect_url != '' && redirect_url != 'undefined' && redirect_url != null){
        window.location.href = redirect_url;
      }
    })
  }
  
  $('.three_block_grid .three_block_list .three_block_inner_cnt a.button_learn_more').on('click',function(e){
    e.preventDefault();
    var popup_id = $(this).attr('data-popup');
    $('.pop-up-wrapper[data-popup-id="'+popup_id+'"]').css('display','flex');
  })

  if($('.featureSlider').length > 0){
    $('.featureSlider').slick({
      dots:!0,
      infinite:!0,
      speed:300,
      arrows:!1,
      dots:!1,
      slidesToShow:1,
      slidesToScroll:1,
      prevArrow:"<button type='button' name='slider-prev-button' class='prev-arrow slider-arrow'><img src='https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Vector_1.svg?v=1699876406' alt='image'><button>"
      ,nextArrow:"<button type='button' name='slider-next-button' class='next-arrow slider-arrow'><img src='https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Vector_2.svg?v=1699876406' alt='image'><button>",
      adaptiveHeight:!0,
      responsive:[
        {  
          breakpoint:767,
          settings:{
            arrows:!1
          }
        }
      ]
    });
  }
 
  if($('.three_block_slider').length > 0){
    $(".three_block_slider").slick({
      arrows:!1,
      dots:!1,
      responsive:[
        {
          breakpoint:1200,
          settings:{
            slidesToShow:2,
            slidesToScroll:1,
            infinite:!0,
            dots:!0
          }
        },
        {
          breakpoint:767,
          settings:{
            slidesToShow:2,
            slidesToScroll:1,
            dots:!0
          }
        },
        {
          breakpoint:576,
          settings:{
            slidesToShow:1,
            slidesToScroll:1,
            dots:!0
          }
        }
      ]
    })
  }

  if($('.featureSlider').length > 0){
    var tumb_img=$('.thumbnail_image_li').length;

    if($(window).width()<768){
      var curr_width=$(window).width();
      var thumbnail_length=$('.imgNavList').attr('block-size');
        
      if(thumbnail_length>5){
        $('.imgNavList').slick({
          dots:!1,
          infinite:!0,
          arrows:!1,
          slidesToShow:5,
          slidesToScroll:1,
          asNavFor:".featureSlider",
          focusOnSelect:!0,
          prevArrow:"<button type='button' class='prev-arrow slider-arrow'><img src='https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Vector_1.svg?v=1699876406' alt='image'><button>",
          nextArrow:"<button type='button' class='next-arrow slider-arrow'><img src='https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Vector_2.svg?v=1699876406' alt='image'><button>"
        })
      }
    }

    $('.featureSlider').on('afterChange',function(event,slick,currentSlide,nextSlide){
      var dataId=$(slick.$slides[currentSlide]).data('slick-index');
      var id=$(slick.$slides[currentSlide]).attr('id');
      if(id!=''&&id!='undefined'&&id!=null){
        $('ul.imgNavList li.imgnavitem').each(function(){
          if($(this).attr('data-slide-id')==id){
            $(this).addClass('active')
          }else{
            $(this).removeClass('active')
          }
        })
      }
    });

    $('.thumbnail_image_li').click(function(){
      var slide_id=$(this).attr('data-slide-id');
      $('.featureSlider .w-slide').each(function(){
        var slick_id=$(this).attr('id');
        if(slick_id==slide_id){
          var slick_index=$(this).attr('data-slick-index');
          $('.featureSlider').slick('slickGoTo',slick_index)
        }
      })
    })

    $(".imgnavitem").click(function(){
      $(this).addClass('active').siblings().removeClass('active');
    })
  }

})();

/* caesar-cushie-home-banner-winner-permanent-sleeper-sofa */
(function(){
  var TARGET='/collections/sleeper-sofa';
  var HERO_SECTION_ID='shopify-section-template--26622801740067__image_text_overlay_AJFefw';
  function isHome(){var p=window.location.pathname||'/'; return /^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(p);}
  if (!isHome()) return;
  function apply(){
    if(!isHome()) return;
    var section=document.getElementById(HERO_SECTION_ID);
    if(!section){var btn=document.querySelector('a.banner_btn_link[href]'); section=btn?btn.closest('.shopify-section,.image_text_overlay_container,.banner-homerefresh'):null;}
    var root=section||document;
    root.querySelectorAll('a.banner_btn_link[href], a[href="/collections/all"], a[href="https://www.cushiehome.com/collections/all"]').forEach(function(link){
      if(link.closest('.header-old, .mainheader-wrapper, .mobile_sidebar, .mega-menu, footer')) return;
      link.setAttribute('href', TARGET);
      link.setAttribute('data-caesar-home-banner-winner','sleeper_sofa');
      link.setAttribute('data-caesar-home-banner-winner-source','live_theme_asset_guard');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  var n=0,t=setInterval(function(){n++; apply(); if(n>=20) clearInterval(t);},250);
})();
/* end caesar-cushie-home-banner-winner-permanent-sleeper-sofa */


$(window).on('scroll', function () {
  var sticky = $('.stickyEl');
  var target = $('.last-fourth-step');

  // Exit if either element doesn't exist
  if (!sticky.length || !target.length) {
    return;
  }

  var targetOffset = target.offset().top;
  var scrollTop = $(window).scrollTop();

  if (scrollTop + sticky.outerHeight() >= (targetOffset + 180)) {
    sticky.addClass('unstuck');
  } else {
    sticky.removeClass('unstuck');
  }
});


let discountCouponsArr = ['end of year sale, 10% off','end of year sale, 15% off','end of year sale, 20% off','end of year sale,  20% off','end of year sale, 25% off','end of year sale, 30% off'];
const shop_currency = document.body.getAttribute('data-currency');

const discountCoupon = document.getElementById("discount-coupon");
if (discountCoupon) {
  discountCoupon.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent default form submit
      document.getElementById("discountApply").click(); // optionally trigger apply
    }
  });
}

document.addEventListener("DOMContentLoaded", async function () {
  const discountInput = document.getElementById("discount-coupon");
  if (!discountInput) return;
  const discountMessage = document.getElementById("discountMessage");
  const appliedDiscountElement = document.querySelector(".appliedDiscountCode");
  const cartFooter = document.querySelectorAll('.cart-footer-2');
  const cartLoader = document.querySelectorAll('.cart-footer-2 .cart-total-loader');

  let automatic_discount = 'false';
  if(appliedDiscountElement){
    automatic_discount = appliedDiscountElement.getAttribute("data-automatic-discount");
  }

  function showLoader(show = true) {
    cartFooter.forEach(footer => footer.classList.toggle('show-loader', show));
    cartLoader.forEach(loader => loader.classList.toggle('hide', !show));
  }

  function showDiscountMessage(msg, color = "black") {
    discountMessage.textContent = msg;
    discountMessage.style.color = color;
  }

  function formatPrice(price) {
    return shop_currency+`${price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { cache: "no-store" });
    return res.json();
  }

  function updateCartAfterDiscount(cart) {
    const subtotalDiv = document.getElementById("cart-subtotal");
    // const totaldiscount = document.getElementById("cart-page-discount-total");
    const totalDiv = document.getElementById("cart-page-total");
    const shipping = document.querySelector('.cartShipping');
    const displayedCodes = new Set();

    let subtotal = cart.original_total_price / 100;
    let total = cart.total_price / 100;
    // let discount = subtotal - total;

    subtotalDiv.textContent = formatPrice(subtotal);
    totalDiv.textContent = formatPrice(total);

  } 


  function updateDiscountCodes(cart) {
    const shipping = document.querySelector('.cartShipping');
    const displayedCodes = new Set();

    if($('.cart-lines .cartDiscountRow').length > 0){
      $('.cart-lines .cartDiscountRow').remove();
    }

    if (cart.cart_level_discount_applications?.length) {
      for (let allocation of cart.cart_level_discount_applications) {
        const discount_code = allocation.title?.toLowerCase();
        let amount = allocation.total_allocated_amount;

        if(amount){
          amount = parseFloat(amount/100);
          amount = amount.toFixed(2);
        }

        if (!discount_code) continue;

        console.log(discount_code);

        // Then insert into DOM only if not already displayed
        if (!displayedCodes.has(discount_code)) {
          displayedCodes.add(discount_code);

          const cartlevelDiscount = document.createElement('div');
          cartlevelDiscount.className = 'cart-line cartDiscountRow';

          let code_to_match = discount_code.replace(/['"“”‘’]/g, '').trim();

          if (discountCouponsArr.includes(code_to_match)){
              cartlevelDiscount.innerHTML = `
              <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}</span>
              <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
            `;
            
          }else{
            cartlevelDiscount.innerHTML = `
              <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}<span class="removeDiscountCode">x</span></span>
              <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
            `;
          }
          
          shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
        }
      }
    }

    // --- Insert item-level discounts ---
    if (cart.items?.length) {
      for (let item of cart.items) {
        if (item.line_level_discount_allocations?.length) {
          for (let allocation of item.line_level_discount_allocations) {
            const discount_code = allocation.discount_application?.title?.toLowerCase();
            let amount = allocation.discount_application?.total_allocated_amount;

            if(amount){
              amount = parseFloat(amount/100);
              amount = amount.toFixed(2);
            }

            if (discount_code && !displayedCodes.has(discount_code)) {
              displayedCodes.add(discount_code);
              const cartlevelDiscount = document.createElement('div');
              cartlevelDiscount.className = 'cart-line cartDiscountRow';

              let code_to_match = discount_code.replace(/['"“”‘’]/g, '').trim();

              if(discountCouponsArr.includes(code_to_match)){
                  cartlevelDiscount.innerHTML = `
                  <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}</span>
                  <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
                `;
              }else{
                cartlevelDiscount.innerHTML = `
                  <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}<span class="removeDiscountCode">x</span></span>
                  <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
                `;
              }
              
              shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
            }
          }
        }
      }
    }

  }


  // Remove a specific discount code by name and re-apply the rest, no page reload
  async function removeDiscountAjax(discountToRemove) {
    try {
      // 1) Get current cart
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // 2) Collect discount codes (only manual/discount_code type)
      const codes = [];

      if (Array.isArray(cart.cart_level_discount_applications)) {
        for (const app of cart.cart_level_discount_applications) {
          if (app?.type === 'discount_code' && app.title) codes.push(app.title);
        }
      }

      for (const item of cart.items || []) {
        for (const alloc of item.line_level_discount_allocations || []) {
          const dapp = alloc.discount_application;
          if (dapp?.type === 'discount_code' && dapp.title) codes.push(dapp.title);
        }
      }

      // 3) Deduplicate and remove requested code
      const uniqueCodes = [...new Set(codes.map(c => c.trim()))];
      const remaining = uniqueCodes.filter(
        c => c.toLowerCase() !== discountToRemove.toLowerCase()
      );

      // 4) Clear existing discounts
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });

      // 5) Reapply remaining (if any)
      if (remaining.length > 0) {
        const discountCodes = remaining.map(c => encodeURIComponent(c)).join(',');
        await fetch('/discount/' + discountCodes, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow'
        });
      }

      // 6) Fetch updated cart JSON
      const updatedRes = await fetch('/cart.js');
      const updatedCart = await updatedRes.json();

      // 7) Now update your cart drawer DOM with updatedCart
      updateCartAfterDiscount(updatedCart); // 🔹 you'll define this
      showDiscountMessage("", "");
      discountInput.value = ""; 

      return updatedCart;

    } catch (err) {
      console.error('Error removing discount:', err);
      throw err;
    }
  }


  async function checkDiscountOnLoad() {
    try {
      const cart = await getCart();
      const shipping = document.querySelector('.cartShipping');

      if (!shipping) return; // exit if shipping element is missing

      const displayedCodes = new Set();

      if($('.cart-lines .cartDiscountRow').length > 0){
        $('.cart-lines .cartDiscountRow').remove();
      }

      // --- Cart-level discounts ---
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        const applied = cart.cart_level_discount_applications[0].title;
        discountInput.value = applied;

        cart.cart_level_discount_applications.forEach(discount => {
          console.log(discount);
          const code = discount.title.toLowerCase();
          let amount = discount.total_allocated_amount;

          if(amount){
            amount = parseFloat(amount/100);
            amount = amount.toFixed(2);
          }
        
          if (!displayedCodes.has(code)) {
            displayedCodes.add(code);

            const cartlevelDiscount = document.createElement('div');
            cartlevelDiscount.className = 'cart-line cartDiscountRow';

            let code_to_match = code.replace(/['"“”‘’]/g, '').trim();

            if (discountCouponsArr.includes(code_to_match)){
              cartlevelDiscount.innerHTML = `
              <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${code}">${code}</span>
              <div class="appliedDiscountAmount" class="semi-text">-${shop_currency}${amount}</div>
            `;
            }else{
              cartlevelDiscount.innerHTML = `
                <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${code}">${code}<span class="removeDiscountCode">x</span></span>
                <div class="appliedDiscountAmount" class="semi-text">-${shop_currency}${amount}</div>
              `;
            }

            shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
          }
        });
      }

      // --- Line-level discounts ---
      cart.items.forEach(item => {
        if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
          item.line_level_discount_allocations.forEach(allocation => {
            const code = allocation.discount_application.title.toLowerCase();
            let amount = allocation.discount_application.total_allocated_amount;

            if(amount){
              amount = parseFloat(amount/100);
              amount = amount.toFixed(2);
            }

            if (!displayedCodes.has(code)) {
              displayedCodes.add(code);

              const cartlevelDiscount = document.createElement('div');
              cartlevelDiscount.className = 'cart-line cartDiscountRow';

              let code_to_match = code.replace(/['"“”‘’]/g, '').trim();

              if (discountCouponsArr.includes(code_to_match)){
                cartlevelDiscount.innerHTML = `
                  <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${code}">${code}</span>
                  <div class="appliedDiscountAmount" class="semi-text">-${shop_currency}${amount}</div>
                `;
                
              }else{
                cartlevelDiscount.innerHTML = `
                  <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${code}">${code} <span class="removeDiscountCode">x</span></span>
                  <div class="appliedDiscountAmount" class="semi-text">-${shop_currency}${amount}</div>
                `;
              }
              

              shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
            }
          });
        }
      });

      updateCartAfterDiscount(cart);

    } catch (err) {
      console.error("Error loading cart:", err);
    }
  }

  /* await checkDiscountOnLoad(); */

  if (discountInput && document.querySelector('.cartShipping')) {
    await checkDiscountOnLoad();
  }



  // Apply Discount
  $(document).on("click", "#discountApply", async function (e) {
    e.preventDefault();
    const code = discountInput.value.trim();
    const inputCode = code.toLowerCase();
    if (!code) {
      showDiscountMessage("Please enter a discount code.", "red");
      return;
    }

    showLoader(true);

    try {
      const shipping = document.querySelector('.cartShipping');
      if (!shipping) throw new Error("Shipping element not found.");

      // Check if code is already applied
      const applied_discount = $('.appliedDiscountCode').text().trim().toLowerCase();
      if (applied_discount === inputCode) {
        showDiscountMessage("Already applied!", "red");
        showLoader(false);
        return;
      }

      // --- Validate the entered code without exposing the full discount list ---
      const validationEndpoint = "https://scripts.lifely.network/cloudflare/worker/cushie-discount-validator/validate?code=" + encodeURIComponent(code);
      const response = await fetch(validationEndpoint, { method: "GET" });
      if (!response.ok) throw new Error(`Network error: ${response.status}`);
      const data = await response.json();

      if (!data.success || data.valid !== true) {
        showDiscountMessage(`${code} does not exist.`, "red");
        showLoader(false);
        return;
      }

      // --- Apply discount via Shopify ---
      const discountResponse = await fetch("/discount/" + encodeURIComponent(code), {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });

      if (!discountResponse.ok) {
        showDiscountMessage("Something went wrong. Please try again.", "red");
        showLoader(false);
        return;
      }

      // wait a little for Shopify to apply server-side
      await new Promise(r => setTimeout(r, 500));
      const updatedCart = await getCart();

      const displayedCodes = new Set();
      let nowAppliedOrder = false;
      let nowAppliedItem = false;

      if($('.cart-lines .cartDiscountRow').length > 0){
        $('.cart-lines .cartDiscountRow').remove();
      }

      // --- Insert cart-level discounts ---
      if (updatedCart.cart_level_discount_applications?.length) {
        for (let allocation of updatedCart.cart_level_discount_applications) {
          const discount_code = allocation.title?.toLowerCase();
          let amount = allocation.total_allocated_amount;

          if(amount){
            amount = parseFloat(amount/100);
            amount = amount.toFixed(2);
          }

          if (!discount_code) continue;

          // First check if it's the code we just applied
          if (discount_code === inputCode) nowAppliedOrder = true;

          // Then insert into DOM only if not already displayed
          if (!displayedCodes.has(discount_code)) {
            displayedCodes.add(discount_code);

            const cartlevelDiscount = document.createElement('div');
            cartlevelDiscount.className = 'cart-line cartDiscountRow';

            let code_to_match = discount_code.replace(/['"“”‘’]/g, '').trim();

            if (discountCouponsArr.includes(code_to_match)){
              cartlevelDiscount.innerHTML = `
                <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}</span>
                <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
              `;
            }else{
                cartlevelDiscount.innerHTML = `
                <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${discount_code}">${discount_code}<span class="removeDiscountCode">x</span></span>
                <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
              `;
            }
            shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
          }
        }
      }

      // --- Insert item-level discounts ---
      if (updatedCart.items?.length) {
        for (let item of updatedCart.items) {
          if (item.line_level_discount_allocations?.length) {
            for (let allocation of item.line_level_discount_allocations) {
              const title = allocation.discount_application?.title?.toLowerCase();
              let amount = allocation.discount_application?.total_allocated_amount;

              if(amount){
                amount = parseFloat(amount/100);
                amount = amount.toFixed(2);
              }

              if (title && !displayedCodes.has(title)) {
                displayedCodes.add(title);
                if (title === inputCode) nowAppliedItem = true;

                const cartlevelDiscount = document.createElement('div');
                cartlevelDiscount.className = 'cart-line cartDiscountRow';

                let code_to_match = title.replace(/['"“”‘’]/g, '').trim();

                if (discountCouponsArr.includes(code_to_match)){
                  cartlevelDiscount.innerHTML = `
                    <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${title}">${title}</span>
                    <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
                  `;
                }else{
                  cartlevelDiscount.innerHTML = `
                    <span data-automatic-discount="" class="appliedDiscountCode" data-discount="${title}">${title}<span class="removeDiscountCode">x</span></span>
                    <div class="appliedDiscountAmount semi-text">-${shop_currency}${amount}</div>
                  `;
                }
                
                shipping.parentNode.insertBefore(cartlevelDiscount, shipping);
              }
            }
          }
        }
      }

      // --- Show discount messages ---
      if (nowAppliedOrder || nowAppliedItem) {
        showDiscountMessage("Discount applied!", "green");
      } else {
        showDiscountMessage(`${code} couldn’t be used with your existing discount.`, "red");
      }

      updateCartAfterDiscount(updatedCart);
    } catch (err) {
      console.error("Apply discount error:", err);
      showDiscountMessage("Network error. Please try again later.", "red");
    }

    showLoader(false);
  });

  /* if(automatic_discount == 'false'){
    document.querySelector('.appliedDiscountCode').addEventListener('click', function (e) {
      e.preventDefault();
      showLoader(true);
      removeDiscountAjax().finally(() => showLoader(false));
    });
  } */


  $(document).on('click', '.cart-line.cartDiscountRow .appliedDiscountCode .removeDiscountCode', function(e){
    e.preventDefault();
    showLoader(true);
    var disount_code = $(this).closest('.appliedDiscountCode').attr('data-discount');
    $(this).closest('.cartDiscountRow').remove();
    removeDiscountAjax(disount_code).finally(() => showLoader(false));
  })
  
});
  